export default {
  name: "StyleTextarea",
  props: {
    id: {
      type: String,
      default: "style-textarea"
    },
    rows: {
      type: [Number, String],
      default: 4
    },
    placeholder: {
      type: String,
      default: "请输入内容..."
    },
    modelValue: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    className: {
      type: [String, Array, Object],
      default: ""
    }
  },
  mounted() {
    document.getElementById('content').focus();
  }
};